 $(".product-upsell-form").submit(function(e){
    e.preventDefault()
    let form = $(this)
    let formData = $(this).serialize();
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: formData,
        success: function (data) {
            jQuery.getJSON('/cart.js', function(cart) {
              
            });
          // This is event for sidecart
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data, //replace this variable with response
            // addToCartBtn: this.addToCart
          }
        }));
        },
        error: function (err) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: {
            errorMessage: error.description
          }
        }));
        }
    });
  });

  $(".cart-upsell .product-upsell-wrapper").owlCarousel({
    slideSpeed: 300,
    paginationSpeed: 400,
    nav: false,
    dots: false,
    loop:true,
    navRewind: false,
    autoplay: false,
    autoplayTimeout: 5000,
    responsive: {
      0: {
        items: 1,
        stagePadding:10,
      },
    },
  });